import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Input, LabelText, SubmitButton, FlexContainer, LeftBackButtonText, H1Text, Spinner, Hr, Text, Img, InputWrapper } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { axiosLoginInstance, BASE_URLS } from "../../api";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import ArrowIcon from "../../assets/imgs/forwardarrow.svg";
import OpenIcon from "../../assets/imgs/eyeopen.svg";
import HiddenIcon from "../../assets/imgs/eyeclose.svg";

type Props = {
    history: {
        push: Function,
    },
}
const ResetPassword = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [readOnly, setReadOnly] = useState([]);
    const [showerrorMessage, setShowErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const email = localStorage.getItem('email');
    const [showPassword, setShowPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState(false);
    const [confirmCode, setConfirmCode] = useState(false);

    const { handleSubmit, errors, control } = useForm();
    const onSubmit = async (data) => {
        try {
            await axiosLoginInstance.post(BASE_URLS.RESET_PASSWORD, {
                email,
                password: data.newpassword,
                confirmationCode: data.confirmationCode,
              });
            localStorage.removeItem('email');
            setSuccess(true);
        } catch (e) {
            setShowErrorMessage(true);
            setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
        }
    }

    useEffect(() => {
        if (success) {
            props.history.replace('/login');
        }
    }, [success]);

    const isValidate = (data:string) => {
        const matchPassword = control.getValues().newpassword;
        if (data !== matchPassword) {
            return "Must match password typed above";
        }
    }

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                    <LeftBackButtonText
                            onClick={() => {props.history.push(`/forgotpassword`);}}
                        >
                            Back
                      </LeftBackButtonText>
                        <H1Text>
                            Configure Payments
                      </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                >
                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        ACCOUNT SETUP
                    </H1Text>
                    <Text className="px-1 px-md-4" paddingBottom="8px">
                        Setup a new password
                    </Text>
                    <Hr />
                    <div className="px-1 px-md-4 mt-2">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <LabelText className="mt-4 mb-2">
                                New Password
                           </LabelText>
                           <InputWrapper marginBottom="0px" borderRadius="4px" width='298px'>
                            <Controller
                                defaultValue={""}
                                control={control}
                                color={errors.newpassword ? "red" : "inherit"}
                                border="0px !important"
                                name="newpassword"
                                placeholder="New Password"
                                rules={{
                                    required: 'Password is required',
                                    pattern: {
                                        value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
                                        message: 'The password is invalid',
                                    },
                                }}
                                as={<Input
                                    style={{
                                    marginTop: "0",
                                    marginBottom: "0px",
                                    width: "268px",
                                }}
                                type={showPassword ? "text" : "password"} readOnly={readOnly && readOnly.includes("newpassword")} />}
                            />
                            <Img verticalAlign='middle' onClick={() => setShowPassword(!showPassword)} src={showPassword ? OpenIcon : HiddenIcon} />
                            </InputWrapper>
                            <ErrorMessage
                                errors={errors}
                                name="newpassword"
                                render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                            />
                            <LabelText className="mt-4 mb-2">
                                Confirm New Password
                           </LabelText>
                           <InputWrapper marginBottom="0px" borderRadius="4px" width='298px'>
                            <Controller
                                defaultValue={""}
                                control={control}
                                color={errors.confirmpassword ? "red" : "inherit"}
                                border="0px !important"
                                name="confirmpassword"
                                placeholder="Confirm New Password"
                                rules={{
                                    required: 'Password is required',
                                    validate: isValidate
                                }}
                                as={<Input
                                    style={{
                                        marginTop: "0",
                                        marginBottom: "0px",
                                        width: "268px",
                                    }}
                                    type={confirmPassword ? "text" : "password"} readOnly={readOnly && readOnly.includes("confirmpassword")} />}
                            />
                            <Img verticalAlign='middle' onClick={() => setConfirmPassword(!confirmPassword)} src={confirmPassword ? OpenIcon : HiddenIcon} />
                            </InputWrapper>
                            <ErrorMessage
                                errors={errors}
                                name="confirmpassword"
                                render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                            />
                            <LabelText className="mt-4 mb-2">
                            Verification Code
                           </LabelText>
                           <InputWrapper marginBottom="0px" borderRadius="4px" width='298px'>
                            <Controller
                                defaultValue={""}
                                control={control}
                                color={errors.confirmationCode ? "red" : "inherit"}
                                border="0px !important"
                                name="confirmationCode"
                                placeholder="Verification Code"
                                rules={{
                                    required: 'Verification Code is required',
                                }}
                                as={<Input
                                    style={{
                                        marginTop: "0",
                                        marginBottom: "0px",
                                        width: "268px",
                                    }}
                                    type={confirmCode ? "text" : "password"} readOnly={readOnly && readOnly.includes("confirmationCode")} />}
                            />
                            <Img verticalAlign='middle' onClick={() => setConfirmCode(!confirmCode)} src={confirmCode ? OpenIcon : HiddenIcon} />
                            </InputWrapper>
                            <ErrorMessage
                                errors={errors}
                                name="confirmationCode"
                                render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                            />
                            <Text className="mt-3 mb-2" fontSize="12px" marginTop="4px" marginBottom="0px" style={{ width: '292px' }}>
                                Please enter the verification code sent in your email along with the new password
                            </Text>
                            <div>
                                <SubmitButton
                                    style={{ width: '292px' }}
                                    type="submit"
                                >Next <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                            </div>
                            {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                        </form>
                    </div>
                </FlexContainer>
            </>
        } />
    )
};

export default ResetPassword;
